module.exports = __webpack_public_path__ + "static/media/Switch.80590d6f.svg";